import { useEffect, useState } from "react";

import { FaBars, FaHome, FaTimes } from "react-icons/fa";

import { Link, NavLink, useLocation } from "react-router-dom";

import DarkModeToggle from "./DarkModeToggle";
import SearchBar from "./SearchBar";

import { PUBLIC_CATEGORIES } from "../config/categories";

import siteConfig from "../config/siteConfig";

import "../styles/navbar.css";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const location = useLocation();

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname, location.search]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";

    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === "Escape") {
        setMenuOpen(false);
      }
    };

    document.addEventListener("keydown", handleEscape);

    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, []);

  const { name, logoText, topbarText, navbarTagline, routes } = siteConfig;

  return (
    <header className="public-header">
      <div className="public-topbar">
        <div className="public-topbar-inner">
          <span>{topbarText}</span>

          <Link to={routes.about}>About this website</Link>
        </div>
      </div>

      <nav className="navbar" aria-label="Main navigation">
        <div className="navbar-brand-row">
          <Link
            to={routes.home}
            className="logo"
            aria-label={`${name} homepage`}
          >
            <span className="logo-mark">{siteConfig.logoMark}</span>

            <span className="logo-copy">
              <strong>{logoText}</strong>

              <small>{navbarTagline}</small>
            </span>
          </Link>

          <div className="nav-right">
            <SearchBar />

            <DarkModeToggle />

            <button
              type="button"
              className="menu-toggle"
              aria-label={menuOpen ? "Close navigation" : "Open navigation"}
              aria-expanded={menuOpen}
              aria-controls="public-navigation-links"
              onClick={() => setMenuOpen((current) => !current)}
            >
              {menuOpen ? <FaTimes /> : <FaBars />}
            </button>
          </div>
        </div>

        <div
          id="public-navigation-links"
          className={menuOpen ? "nav-links active" : "nav-links"}
        >
          <NavLink
            to={routes.home}
            end
            className={({ isActive }) => (isActive ? "active-link" : "")}
          >
            <FaHome className="nav-icon" />
            Home
          </NavLink>

          {PUBLIC_CATEGORIES.map((category) => {
            const Icon = category.icon;

            return (
              <NavLink
                key={category.slug}
                to={`/category/${category.slug}`}
                className={({ isActive }) => (isActive ? "active-link" : "")}
              >
                <Icon className="nav-icon" />

                {category.title}
              </NavLink>
            );
          })}
        </div>
      </nav>

      {menuOpen && (
        <button
          type="button"
          className="mobile-overlay show"
          aria-label="Close navigation"
          onClick={() => setMenuOpen(false)}
        />
      )}
    </header>
  );
};

export default Navbar;
